import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

interface IDistributorUser {
  username: string;
  email: string;
  password?: string;
  distributorUserType: string;
}
export default function useCreateDistributorUserMaster() {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  async function execute(
    distributorId: string,
    distributorUser: IDistributorUser,
  ) {
    try {
      setLoading(true);
      const response = await api.post(
        `v1/backoffice/admins/distributor-user/${distributorId}`,
        {
          username: distributorUser.username,
          email: distributorUser.email,
          distributorUserType: distributorUser.distributorUserType,
        },
      );

      if (response.status === 201) {
        history.goBack();
        toast.success(ToastMessages.distributorUser.success.registerUserMaster);
      }
    } catch (error) {
      return toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
